import { handleActions } from "redux-actions";

import { SMART_ORDERS } from "./action-types";
import { TAPIResponse } from "../../types";
import { TSmartOrders } from "./actions";

export const smartOrders = handleActions(
    {
        [SMART_ORDERS.FETCH.START]: (
            state: TAPIResponse<TSmartOrders, string>
        ): TAPIResponse<TSmartOrders, string> => ({
            data: undefined,
            error: undefined,
            loaded: undefined,
            isLoading: true,
        }),
        [SMART_ORDERS.FETCH.SUCCESS]: (
            state: TAPIResponse<TSmartOrders, string>,
            { payload }: any
        ): TAPIResponse<TSmartOrders, string> => ({
            data: payload,
            error: null,
            loaded: true,
            isLoading: false,
        }),
        [SMART_ORDERS.FETCH.ERROR]: (
            state: TAPIResponse<TSmartOrders, string>,
            { payload }: any
        ): TAPIResponse<TSmartOrders, string> => ({ data: undefined, error: payload, loaded: false, isLoading: false }),
    },
    {
        data: undefined,
        error: undefined,
        loaded: undefined,
        isLoading: undefined,
    }
);
